import { useTranslation } from 'react-i18next';
import { useMe } from '../lib/auth/authContext';
import { useActiveContext } from '../lib/context/useActiveContext';
import { useDateFormatter } from '../lib/dates/useDateFormatter';
import { HomeDashboard } from '../home';

function HomeWelcome({
  scopeName,
  timeZoneId,
}: {
  readonly scopeName: string;
  readonly timeZoneId?: string | null;
}) {
  const { t, i18n } = useTranslation('shell');
  const me = useMe();
  const dates = useDateFormatter();
  const now = new Date();
  const date = new Intl.DateTimeFormat(i18n.resolvedLanguage ?? 'pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    ...(timeZoneId ? { timeZone: timeZoneId } : {}),
  }).format(now);
  return (
    <header className="flex flex-col gap-2">
      <p className="giyus-overline">
        {scopeName} · {date}
      </p>
      <h1 className="text-display font-semibold tracking-tight text-heading">
        {t('home.greeting', { name: me.user.displayName.split(' ')[0] })}
      </h1>
      <p className="text-body text-muted-foreground">{t('home.networkSubtitle')}</p>
      {timeZoneId && (
        <p className="text-caption text-muted-foreground" data-testid="site-time-zone">
          {t('home.siteTimeZone', { zone: timeZoneId })} ·{' '}
          {t('home.now', { when: dates.dateTime(now) })}
        </p>
      )}
    </header>
  );
}

export function TenantHomePage() {
  const { context, timeZoneId } = useActiveContext();
  if (!context) return null;
  return (
    <section data-testid="home">
      <HomeDashboard
        scope="tenant"
        tenantCode={context.code}
        tenantId={context.tenantId}
        header={<HomeWelcome scopeName={context.name} timeZoneId={timeZoneId} />}
      />
    </section>
  );
}

export function NetworkHomePage() {
  const { t } = useTranslation('shell');
  return (
    <section data-testid="network-home">
      <HomeDashboard
        scope="network"
        tenantCode={null}
        tenantId={null}
        header={<HomeWelcome scopeName={t('home.networkTitle')} />}
      />
    </section>
  );
}
